export default {
  username: {
    label: '用户ITcode',
    type: 'input',
    rules: [{ required: true, message: '请输入用户ITcode' }], // 校验
  },
  name: {
    label: '用户名称',
    type: 'input',
    rules: [{ required: true, message: '请输入用户名称' }], // 校验
  },
  department: {
    label: '所属部门',
    type: 'input',
    // optionList: [
    //   { label: '技术', value: '1' },
    //   { label: '商务', value: '2' },
    //   { label: '信用', value: '3' },
    //   { label: '业务', value: '4' },
    //   { label: '其他', value: '5' }
    // ],
    rules: [{ required: true, message: '请选择所属部门' }], // 校验
  },
  mobile: {
    label: '联系电话',
    type: 'input',
    maxLength: 11,
    rules: [{ required: true, message: '请输入联系电话' }], // 校验
  },
  email: {
    label: '联系邮箱',
    type: 'input',
    rules: [{ required: true, message: '请输入联系邮箱' }], // 校验
  },
  roleIds: {
    label: '所属角色',
    slotName: 'role',
  },
}
